var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createDocument } from "@/06-shared/api";
import { useNotifyError } from "@/06-shared/lib/useNotifyError";
import { PopupButton, PopupInput, PopupWindow } from "@/06-shared/ui/popups";
import { useState } from "react";
export const CreateDirectory = ({ isOpen, parentId = null, onSuccess, onClose }) => {
    const [dirName, setDirName] = useState("");
    const showError = useNotifyError();
    const onCreateDir = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield createDocument({
                name: dirName,
                type: "directory",
                parentId
            });
            onSuccess();
        }
        catch (error) {
            showError(error);
        }
        finally {
            onClose();
        }
    });
    return (isOpen ? (_jsxs(PopupWindow, Object.assign({ name: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0434\u0438\u0440\u0435\u043A\u0442\u043E\u0438\u044E", onClose: () => { onClose(); } }, { children: [_jsx(PopupInput, { name: "\u0418\u043C\u044F \u0434\u0438\u0440\u0435\u043A\u0442\u043E\u0440\u0438\u0438", setInput: (data) => setDirName(data), onEnter: onCreateDir, autoFocus: true }), _jsx(PopupButton, { name: "[Ok]", onClick: () => onCreateDir() })] }))) : null);
};
